import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const LocalBusinessSchema = () => {
  const location = useLocation();
  const city = "Nürnberg";
  const streetAddress = "Deidesheimer Str. 4";
  const postalCode = "90469";
  const telephone = "+4915172530302";
  const latitude = 49.4204;
  const longitude = 11.0878;

  useEffect(() => {
    // LocalBusiness + BeautySalon schema
    const localBusinessSchema = {
      "@context": "https://schema.org",
      "@type": "BeautySalon",
      "@id": "https://22studios.de/nuernberg#beautysalon",
      name: `22 Studios ${city}`,
      alternateName: "22 Studios",
      description:
        `22 Studios ist ein Premium Beautystudio in ${city}. Beauty-Behandlungen: Friseur, Gesichtsbehandlung, Wimpernverlängerung, Nageldesign, dauerhafte Haarentfernung.`,
      url: "https://22studios.de/nuernberg",
      telephone,
      email: "info@22studios.de",
      image: "https://22studios.de/og-image.png",
      logo: "https://22studios.de/favicon.png",
      priceRange: "€€",
      currenciesAccepted: "EUR",
      paymentAccepted: "Cash, Credit Card, EC Card",
      address: {
        "@type": "PostalAddress",
        streetAddress,
        addressLocality: city,
        addressRegion: "Bayern",
        postalCode,
        addressCountry: "DE",
      },
      geo: {
        "@type": "GeoCoordinates",
        latitude,
        longitude,
      },
      areaServed: {
        "@type": "City",
        name: city,
        sameAs: "https://de.wikipedia.org/wiki/N%C3%BCrnberg",
      },
      openingHoursSpecification: [
        { "@type": "OpeningHoursSpecification", dayOfWeek: "Tuesday", opens: "09:00", closes: "18:00" },
        { "@type": "OpeningHoursSpecification", dayOfWeek: "Wednesday", opens: "09:00", closes: "18:00" },
        { "@type": "OpeningHoursSpecification", dayOfWeek: "Thursday", opens: "10:00", closes: "20:00" },
        { "@type": "OpeningHoursSpecification", dayOfWeek: "Friday", opens: "10:00", closes: "20:00" },
        { "@type": "OpeningHoursSpecification", dayOfWeek: "Saturday", opens: "09:00", closes: "16:00" },
      ],
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: "5.0",
        bestRating: "5",
        worstRating: "1",
        ratingCount: "150",
        reviewCount: "150",
      },
      hasOfferCatalog: {
        "@type": "OfferCatalog",
        name: "Beauty-Behandlungen",
        itemListElement: [
          {
            "@type": "OfferCatalog",
            name: "Friseur Nürnberg",
            itemListElement: [
              { "@type": "Offer", itemOffered: { "@type": "Service", name: `Friseur ${city}`, alternateName: [`Haare schneiden ${city}`, `Balayage ${city}`, `Haare färben ${city}`, `Spitzen schneiden ${city}`, `Augenbrauen färben ${city}`], description: `Ihr Friseur in ${city} – Balayage, Haare schneiden & färben, Spitzen schneiden, Augenbrauen färben mit Paul Mitchell Produkten` } },
            ],
          },
          {
            "@type": "OfferCatalog",
            name: "Gesichtsbehandlung Nürnberg",
            itemListElement: [
              { "@type": "Offer", itemOffered: { "@type": "Service", name: "Gesichtsbehandlung Nürnberg", alternateName: ["Facial Nürnberg", "GlowSolution Nürnberg", "Aquafacial Nürnberg"], description: "Professionelle Gesichtsbehandlung und Facial in Nürnberg mit GlowSolution Aquafacial, Mikroneedling & iS Clinical" }, priceSpecification: { "@type": "PriceSpecification", price: "49", priceCurrency: "EUR", minPrice: "49", maxPrice: "139" } },
            ],
          },
          {
            "@type": "OfferCatalog",
            name: "Wimpernverlängerung",
            itemListElement: [
              { "@type": "Offer", itemOffered: { "@type": "Service", name: "Wimpernverlängerung Nürnberg", description: "Classic, Volumen und Mega Volumen Wimpernverlängerung" } },
            ],
          },
          {
            "@type": "OfferCatalog",
            name: "Nagelstudio Nürnberg",
            itemListElement: [
              { "@type": "Offer", itemOffered: { "@type": "Service", name: "Nagelstudio Nürnberg", alternateName: ["Maniküre Nürnberg", "Pediküre Nürnberg", "Gelnägel Nürnberg", "Nägel Nürnberg"], description: "Professionelle Maniküre, Pediküre, Gelnägel und Shellac im Nagelstudio Nürnberg" }, priceSpecification: { "@type": "PriceSpecification", price: "55", priceCurrency: "EUR", minPrice: "55", maxPrice: "119" } },
            ],
          },
          {
            "@type": "OfferCatalog",
            name: "Dauerhafte Haarentfernung",
            itemListElement: [
              { "@type": "Offer", itemOffered: { "@type": "Service", name: "Dauerhafte Haarentfernung Diodenlaser Nürnberg", alternateName: ["Diodenlaser Haarentfernung Nürnberg", "Laser Haarentfernung Nürnberg"], description: "Schmerzarme Diodenlaser-Behandlung zur dauerhaften Haarentfernung mit ALIX Secret Twin für alle Hauttypen" } },
            ],
          },
        ],
      },
      sameAs: [
        "https://instagram.com/22studios.nue",
        "https://www.planity.com/de-DE/22-studios-90469-nurnberg",
      ],
    };

    // FAQPage schema
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Wie kann ich einen Termin bei 22 Studios buchen?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Du kannst deinen Wunschtermin ganz einfach online über Planity buchen – 24/7, schnell und unkompliziert. Alternativ erreichst du uns telefonisch unter +49 151 7253 0302 oder per E-Mail an info@22studios.de.",
          },
        },
        {
          "@type": "Question",
          name: "Muss ich bei 22 Studios eine Anzahlung leisten?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Nein, bei 22 Studios ist keine Anzahlung nötig. Du bezahlst erst nach deiner Behandlung direkt im Studio – bar oder mit Karte.",
          },
        },
        {
          "@type": "Question",
          name: "Welche Produkte werden bei 22 Studios verwendet?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Wir arbeiten ausschließlich mit hochwertigen Marken: Paul Mitchell für Haarbehandlungen, iS Clinical für Facials und Glow Solution für Aquafacial-Treatments.",
          },
        },
        {
          "@type": "Question",
          name: "Wie lange dauert eine Wimpernverlängerung?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Ein neues Set dauert ca. 1,5–2,5 Stunden, je nach gewählter Technik (Classic, Volumen oder Mega Volumen). Ein Refill dauert ca. 1–1,5 Stunden und wird alle 2–3 Wochen empfohlen.",
          },
        },
        {
          "@type": "Question",
          name: "Ist die dauerhafte Haarentfernung schmerzhaft?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Dank der integrierten –26°C Kühlung des ALIX Secret Twin Geräts ist die Diodenlaser-Behandlung sehr schmerzarm. Die meisten Kunden empfinden nur ein leichtes Wärmegefühl. Die Technologie ist für alle Hauttypen geeignet.",
          },
        },
        {
          "@type": "Question",
          name: "Wie oft muss ich zur dauerhaften Haarentfernung kommen?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Für optimale Ergebnisse empfehlen wir 6–8 Sitzungen im Abstand von 4–6 Wochen. Bereits nach den ersten Sitzungen wirst du eine deutliche Reduzierung des Haarwuchses bemerken.",
          },
        },
        {
          "@type": "Question",
          name: "Kann ich meinen Termin stornieren oder verschieben?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Ja, Termine können bis zu 24 Stunden vorher kostenfrei über Planity verschoben oder storniert werden. Bei kurzfristigeren Absagen bitten wir um telefonische Kontaktaufnahme.",
          },
        },
        {
          "@type": "Question",
          name: "Wo befindet sich 22 Studios und gibt es Parkplätze?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "22 Studios befindet sich in der Deidesheimer Str. 4, 90469 Nürnberg. Parkplätze sind direkt in der Umgebung vorhanden. Öffnungszeiten: Di–Mi 9–18 Uhr, Do–Fr 10–20 Uhr, Sa 9–16 Uhr.",
          },
        },
      ],
    };

    // SiteNavigationElement schema for sitelinks
    const navigationSchema = {
      "@context": "https://schema.org",
      "@type": "SiteNavigationElement",
      name: ["Haare", "Gesichtsbehandlung", "Nägel", "Team"],
      url: [
        "https://22studios.de/haare",
        "https://22studios.de/facials",
        "https://22studios.de/naegel",
        "https://22studios.de/team",
      ],
    };

    // Inject schemas
    const scriptLB = document.createElement("script");
    scriptLB.type = "application/ld+json";
    scriptLB.id = "schema-local-business";
    scriptLB.textContent = JSON.stringify(localBusinessSchema);

    const scriptFAQ = document.createElement("script");
    scriptFAQ.type = "application/ld+json";
    scriptFAQ.id = "schema-faq";
    scriptFAQ.textContent = JSON.stringify(faqSchema);

    const scriptNav = document.createElement("script");
    scriptNav.type = "application/ld+json";
    scriptNav.id = "schema-navigation";
    scriptNav.textContent = JSON.stringify(navigationSchema);

    document.head.appendChild(scriptLB);
    document.head.appendChild(scriptFAQ);
    document.head.appendChild(scriptNav);

    return () => {
      document.getElementById("schema-local-business")?.remove();
      document.getElementById("schema-faq")?.remove();
      document.getElementById("schema-navigation")?.remove();
    };
    }, [city, postalCode, streetAddress, telephone, latitude, longitude]);

  return null;
};

export default LocalBusinessSchema;
